import _ from 'lodash';
import getMaxDaysForTermMonths from './getMaxDaysForTermMonths';

interface CalculatedInterestAmounts {
    annualInterest: number;
    interestPayable: number;
    monthlyInterest: number;
    monthlyInterestDefault: number;
}

export function calculateInterestAmounts(
    loanAmount: number,
    interestRate: number,
    termMonths: number,
    isInterestMethod365: boolean,
    defaultInterestRate: number = null,
): CalculatedInterestAmounts {
    let monthlyInterest: number;
    let monthlyInterestDefault: number;
    let annualInterest: number;
    let interestPayable: number;

    defaultInterestRate = null === defaultInterestRate ? interestRate + 10 : defaultInterestRate;

    if (!isInterestMethod365) {
        monthlyInterest = loanAmount * (interestRate / 100) / 12;
        monthlyInterestDefault = loanAmount * (defaultInterestRate / 100) / 12;
        annualInterest = monthlyInterest * 12;
        interestPayable = Math.ceil(monthlyInterest * termMonths);
    } else {
        const dailyInterest: number = _.round(loanAmount * (interestRate / 100) / 365, 2);
        const dailyDefaultInterest: number = _.round(loanAmount * (defaultInterestRate / 100) / 365, 2);

        // Monthly interest is worst case scenario of 31-day month.
        monthlyInterest = dailyInterest * 31;
        monthlyInterestDefault = dailyDefaultInterest * 31;
        // Annual interest is worst case scenario of leap year.
        annualInterest = dailyInterest * 366;
        // Interest Payable is maximum number of days for a sequence of term months
        interestPayable = dailyInterest * getMaxDaysForTermMonths(termMonths);
    }

    return {
        annualInterest: _.round(annualInterest, 2),
        interestPayable: _.round(interestPayable, 2),
        monthlyInterest: _.round(monthlyInterest, 2),
        monthlyInterestDefault: _.round(monthlyInterestDefault, 2),
    };
}
